<template>
    <div>
        <h3>Chargement des données</h3>
        <uni-circular-loader />
    </div>
</template>

<script>
    import UniCircularLoader from "../a-elements/UniCircularLoader";
    export default {
        name: "LoadingBlock",
        components: {UniCircularLoader}
    }
</script>

<style scoped lang="scss">
    div{
        height: 100%;
        width: 100%;
        text-align: center;
        >h3{
            margin-bottom: 24px;
        }
    }
</style>
